export const prepareTrendChartData = (data, dataKey) => {
    if (0 === data.length) {
        return data;
    }

    const average = data.map(d => d[dataKey]).reduce((a, b) => a + b, 0) / data.length;
    const previousDataKey = `${dataKey}Previous`;
    let previousDataValue = 0;

    return data.map(item => {
        item[previousDataKey] = previousDataValue;
        item['average'] = average;
        previousDataValue = item[dataKey];

        return item;
    });
};

export const calcGrowth = (current, previous) => {
    return ((current - previous) / previous) * 100;
};

export const getActiveBarIndex = (value, breakpoints) => {
    if (value <= breakpoints[0]) return 3;
    if (value <= breakpoints[1]) return 2;
    if (value <= breakpoints[2]) return 1;
    return 0;
};

export const toBarSegments = colors => {
    const seen = {};
    return colors.map(color => {
        seen[color] = (seen[color] ?? 0) + 1;
        return { color, key: `${color}-${seen[color]}` };
    });
};
